module.exports = __webpack_public_path__ + "img/v2_4.7db34412.png";